import create from "zustand";
import { devtools } from "zustand/middleware";

export type MobileNavigationIsOpen = {
  mobileNavigationIsOpen: boolean;
  setMobileNavigationIsOpen: (isOpen: boolean) => void;
};

export const useMobileNavigationOpenState = create<MobileNavigationIsOpen>(
  devtools(
    (set) => ({
      mobileNavigationIsOpen: false,
      setMobileNavigationIsOpen: (isOpen: boolean) =>
        set(() => ({ mobileNavigationIsOpen: isOpen })),
    }),
    { name: "MOBILE_NAVIGATION_IS_OPEN" },
  ),
);
